import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'react-bootstrap';

import FilterSelector from 'components/search_sidebar/filter_selector';

export default class ColumnSelector extends React.Component {
  static propTypes = {
    currentColumns: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    defaultColumns: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    informationMappings: PropTypes.object.isRequired,
    onCancelColumns: PropTypes.func,
    onSetColumns: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
      currentColumns: this.props.currentColumns
    };
  }

  getColumnMappings = () => {
    const { informationMappings } = this.props;

    let columnMappings = {};
    Object.values(informationMappings).forEach((mapping) => {
      columnMappings = { ...columnMappings, ...mapping.mappings };
    });

    return columnMappings;
  };

  isChecked = (value) => {
    if (Array.isArray(this.state.currentColumns)) return this.state.currentColumns.indexOf(value) >= 0;

    return this.state.currentColumns[value];
  }

  handleSetDefaultColumns = () => this.setState({ currentColumns: this.props.defaultColumns });

  handleCancelColumns = () => {
    const { currentColumns, onCancelColumns } = this.props;
    this.setState({ currentColumns: currentColumns });

    onCancelColumns();
  }

  handleSetColumns = () => {
    const { onSetColumns } = this.props;
    const { currentColumns } = this.state;

    onSetColumns(currentColumns);
  }

  handleSearchChange = (e) => {
    this.setState({
      searchText: e.target.value
    });
  }

  handleColumnChange = (e) => {
    const { currentColumns } = this.state;
    const value = e.target.value;

    if (Array.isArray(this.state.currentColumns)) {
      this.saveArrayColumnChange(value, currentColumns);
      return;
    }

    this.setState({
      currentColumns: {
        ...currentColumns,
        [value]: !currentColumns[value]
      }
    });
  };

  saveArrayColumnChange = (value, currentColumns) => {
    const index = currentColumns.indexOf(value);
    if (index >= 0) {
      this.setState({
        currentColumns: currentColumns.filter(val => val !== value)
      });
    } else {
      const columns = [];
      const columnMappings = this.getColumnMappings();

      Object.keys(columnMappings).each((col) => {
        if (value === col) columns.push(value);
        if (currentColumns.indexOf(col) >= 0) columns.push(col);
      });

      this.setState({
        currentColumns: [...columns]
      });
    }
  }

  renderCheckboxes(mappings) {
    const { searchText } = this.state;

    return Object.keys(mappings).map((column) => {
      if (mappings[column].toLowerCase().includes(searchText.toLowerCase())) {
        return (
          <div className="filter-checkbox" key={column}>
            <Checkbox
              checked={this.isChecked(column)}
              inline={true}
              value={column}
              onChange={this.handleColumnChange}
            > {mappings[column]}
            </Checkbox>
          </div>
        );
      }
    });
  }

  renderColumnOptions(mapping, display = true) {
    const options = this.renderCheckboxes(mapping.mappings).filter(Boolean);
    const columnOptions = [];

    if (options.length > 0 && display) {
      columnOptions.push(
        <h5 className="top-buffer-sm mb-0" key={mapping.key}>{mapping.title}</h5>
      );
      columnOptions.push(options);
    }

    return columnOptions;
  }

  renderColumns = () => {
    const { informationMappings } = this.props;

    const columns = [];
    Object.values(informationMappings).forEach((mapping) => {
      columns.push(this.renderColumnOptions(mapping));
    });

    return columns;
  }

  render() {
    const { searchText } = this.state;

    return (
      <FilterSelector
        searchText={searchText}
        onCancelFilter={this.handleCancelColumns}
        onSearchChange={this.handleSearchChange}
        onSetDefaultFilters={this.handleSetDefaultColumns}
        onSetFilters={this.handleSetColumns}
      >
        {this.renderColumns()}
      </FilterSelector>
    );
  }
}
